import { padNumberToLength } from '../utils/pad-number-to-length';
/**
 * Returns a numerical representation of the minute: 0, 1, ..., 59
 * @hidden
 */
export const getMinuteNumeric = ({ offsetUtcDate }) => {
    return offsetUtcDate.getUTCMinutes();
};
/**
 * Returns a two-digit string representation of the minute: 00, 01, ..., 59
 * @hidden
 */
export const getMinuteTwoDigit = (params) => {
    const minutes = getMinuteNumeric(params);
    return padNumberToLength(minutes, 2);
};
//# sourceMappingURL=minute.js.map